import { call, put } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction, STORAGE } from "../_config";
import { CallApi } from "./api/callApi";
import { setSSOCookie, clearSSOCookie } from "../_common/utils/ssoCookie";

export function* loginUser(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.LOGIN, action.payload, false);
}

export function* loginUserWithOtp(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGIN_WITH_OTP, data);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      localStorage.setItem(STORAGE, resp.data.data.token);
      setSSOCookie(resp.data.data.token);
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: {
          user: resp.data.data.user,
          token: resp.data.data.token,
        },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* loginWithEmail(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGIN_WITH_EMAIL, data);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      localStorage.setItem(STORAGE, resp.data.data.token);
      setSSOCookie(resp.data.data.token);
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: {
          user: resp.data.data.user,
          token: resp.data.data.token,
        },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* registration(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.AUTH.REGISTRATION, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      //console.log("registter", resp);
      localStorage.setItem(STORAGE, resp.data.token);
      setSSOCookie(resp.data.token);
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: {
          user: resp.data.user,
          token: resp.data.token,
        },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* forgotPassword(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.FORGOT_PASSWORD, action.payload, true);
}

export function* resetPassword(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.RESET_PASSWORD, action.payload, true);
}

export function* logoutUser(action: any): any {
  try {
    const data = action.payload;
    //console.log("logout data", data);
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGOUT, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      localStorage.removeItem(STORAGE);
      clearSSOCookie();

      const x: any = localStorage;
      for (let i = 0; i < x.length; i++) {
        // console.log(x?.key(i));
        if (x?.key(i).includes("performanceLeagueSeen_")) {
          localStorage.removeItem(x?.key(i));
        }
      }
      // x.map((item: any) => {
      //   console.log(item);
      //   // if (item.includes("performanceLeagueSeen_")) {
      //   //   localStorage.removeItem(item);
      //   // }
      // });
      yield put({
        type: ACTIONS.AUTH.LOGOUT,
      });
      yield put({
        type: ACTIONS.EVENT.RESET_PICK_ID,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* updateUserProfile(action: any): any {
  const yieldPuts = [{ type: ACTIONS.AUTH.ME, payload: "user" }];
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.UPDATE_PROFILE, action.payload, true, yieldPuts);
}

export function* getUserProfile(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.AUTH.DETAILS, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data) {
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: { user: resp.data.data.user, token: localStorage.getItem(STORAGE) },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    yield put({
      type: ACTIONS.AUTH.LOGOUT,
    });
  }
}

export function* autoLoginWithToken(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.AUTH.AUTO_LOGIN, data);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data) {
      localStorage.setItem(STORAGE, resp.data.data.token);
      setSSOCookie(resp.data.data.token);
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: {
          user: resp.data.data.user,
          token: resp.data.data.token,
        },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* updateDisplayName(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.UPDATE_DISPLAY_NAME, action.payload, true);
}

export function* updateDob(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.UPDATE_DOB, action.payload, true);
}

export function* updateEmail(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.UPDATE_EMAIL, action.payload, true);
}

export function* checkValidToken(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.AUTH.CHECK_VALID_TOKEN, action.payload, true);
}

export function* saveNotification(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.SAVE_NOTIFICATION, action.payload, true);
}

export function* createUpdateUserGame(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.CREATE_UPDATE_USER_GAME, action.payload, true);
}

export function* getRegistrationFieldsData(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.AUTH.REGISTRATION_FIELDS + "/" + action.payload.gameId,
    null,
    true,
  );
}

export function* saveUserPicks(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.SAVE_USER_PICKS, action.payload, true);
}
